import { Box, styled } from "@mui/material";

export const StyledIconBarContainer = styled(Box)`
  position: relative;
  height: 100%;

  .icon-bar-content {
    background-color: ${({ theme }) => theme.palette.biarri.secondary.whiteSmoke};
    height: 100%;
    border-right: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;
